import z from "zod";

const translationPath = "page.4uDlist.generationRule.employee.errors.";

export const employeeSchema = z.object({
  id: z.string().optional(),
  sector: z.string().min(1, translationPath + "sector"),
});

export type TEmployeeForm = z.infer<typeof employeeSchema>;
